module.exports = __webpack_public_path__ + "static/truckslider-10-min-0ac875cd9481fac07e827a5996a6a8c2.jpg";